import React, { useState, useEffect, useCallback } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Spinner from 'react-bootstrap/Spinner';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import axios from 'axios';
import { useNavigate, Link } from "react-router-dom";

const DHPICK = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [daten, setDaten] = useState([]);
  const [filterState, setFilterState] = useState("offen"); // <-- Standard

  // === zentralisierte Fetch-Funktion ===
  const fetchData = useCallback(async (filter) => {
    setLoading(true);
    try {
      const url =
        filter === "offen"
          ? `https://dhworld.dietenmeier-harsch.de/getFilterBestellungen.php?ts=${Date.now()}`
          : `https://dhworld.dietenmeier-harsch.de/getOffeneBestellungen.php?ts=${Date.now()}`;
          const res = await axios.get(url, {
            withCredentials: true
          });
      setDaten([]);
      setTimeout(() => setDaten(res.data.daten || []), 0);
      console.log("API aufgerufen:", url);
    } catch (err) {
      console.error("Fehler beim Laden der Daten:", err);
    } finally {
      setLoading(false);
    }
  }, []);

  // === initialer Aufruf beim ersten Render ===
  useEffect(() => {
    if (localStorage.getItem("loginData") == null) {
      navigate("/dhworld/login");
      return;
    }
    fetchData("offen"); // Standard
  }, [navigate, fetchData]);

  // === erneuter Aufruf bei Filterwechsel ===
  useEffect(() => {
    if (!loading) {
      fetchData(filterState);
    }
  }, [filterState, fetchData]);

  // === Style für aktive Karte ===
  const getCardStyle = (isActive) => ({
    border: isActive ? '3px solid #007bff' : '2px solid transparent',
    borderRadius: '10px',
    textAlign: 'center',
    padding: '20px',
    backgroundColor: isActive ? '#e7f1ff' : '#ffffff',
    boxShadow: isActive ? '0 0 10px rgba(0,123,255,0.4)' : 'none',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
  });

  return (
    <div style={{ backgroundColor: '#eceff2', minHeight: '100vh' }} className="container-fluid">
      <div className="row pt-4">
        <div className='col-12'>
          <Link to="/insight">
            <i style={{ fontSize: '25px' }} className="bi bi-arrow-return-left"></i>
          </Link>
          <br /><br />
          <h1>Bestellung auswählen</h1>
        </div>
      </div>

      {/* --- Umschaltbereich --- */}
      <div className="row pt-4 text-center justify-content-center">
        <div className="col-6 col-md-3" onClick={() => setFilterState("alle")}>
          <div style={getCardStyle(filterState === "alle")}>
            <i className="bi bi-bag" style={{ fontSize: '30px', color: '#007bff' }}></i>
            <div style={{ marginTop: '8px', fontWeight: 600 }}>Alle Bestellungen</div>
          </div>
        </div>

        <div className="col-6 col-md-3" onClick={() => setFilterState("offen")}>
          <div style={getCardStyle(filterState === "offen")}>
            <i className="bi bi-bag-fill" style={{ fontSize: '30px', color: '#007bff' }}></i>
            <div style={{ marginTop: '8px', fontWeight: 600 }}>Offene Bestellungen</div>
          </div>
        </div>
      </div>

      <br /><br />

      {loading ? (
        <Row>
          <Col xs={12} className="text-center">
            <Spinner animation="border" variant="primary" />
          </Col>
        </Row>
      ) : (
        <Row className="g-4">
          {daten && daten.length > 0 ? (
            <Table striped responsive bordered hover>
              <thead>
                <tr>
                  <th>BestellNr</th>
                  <th>Bezeichnung</th>
                  <th>Liefertermin bestätigt</th>
                  <th>Kommission 2</th>
                  <th>Straße</th>
                  <th>Status</th>
                  <th>Sachbearbeiter</th>
                  <th>Erstelldatum</th>
                </tr>
              </thead>
              <tbody>
                {daten.map((v, index) => {
                  let rowStyle = {};
                  switch (v.status) {
                    case "rot":
                      rowStyle = { backgroundColor: '#ffcccc' };
                      break;
                    case "gelb":
                      rowStyle = { backgroundColor: '#fff7b3' };
                      break;
                    default:
                      rowStyle = { backgroundColor: '#ffffff' };
                      break;
                  }

                  return (
<tr
  key={index}
  onClick={() => {
    const kom2 = v.Kommission_Weiteres?.trim() || '';
    const kom1 = v.Kommission_Bezeichng?.trim() || '';

    // Prüfen: Kommission fehlt oder nicht 8-stellig numerisch
    if (!kom2 || kom2 === "") {
      alert("Fehler: Kommission fehlt.\nBitte von Büromitarbeiter nachtragen lassen.");
      return; // Abbruch, keine Navigation
    }

    navigate(
      `/position/${encodeURIComponent(v.Dokument_Nummer)}/${encodeURIComponent(v.Int_DocNr)}`,
      {
        state: {
          kommission: kom2,
          kom1: kom1,
          sachbearbeiter: v.Bearb_Partner?.trim() || '', 
          strasse: v.strasse?.trim() || ''
        }
      }
    );
  }}
  style={{ cursor: 'pointer', ...rowStyle }}
>
                      <td>{v.Dokument_Nummer}</td>
                      <td>{v.Dokument_Infotext}</td>
                      <td>{v.Best_OkayLiefDatumAb}</td>
                      <td>{v.Kommission_Weiteres}</td>
                      <td>{v.strasse}</td>
                      <td>{v.Dokument_Status}</td>
                      <td>{v.Bearb_Partner}</td>
                      <td>{v.Datum_Dokument}</td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          ) : (
            <Col xs={12}>
              <div
                style={{
                  background: '#fff',
                  padding: '1rem',
                  borderRadius: '8px',
                  textAlign: 'center'
                }}
              >
                Keine Bestellungen
              </div>
            </Col>
          )}
        </Row>
      )}
    </div>
  );
};

export default DHPICK;
